import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Phone, Mail, Globe, Heart, Share2 } from "lucide-react";
import { BRAND } from "@/lib/api";

const shareSite = async () => {
  const url = `https://${BRAND.site}`;
  const data = { title: "Hope & Favor", text: "Thoughtfully Curated. Beautifully Given.", url };
  if (navigator.share) { try { await navigator.share(data); } catch { /* cancelled */ } return; }
  try { await navigator.clipboard.writeText(url); toast.success("Link copied — share Hope & Favor 💛"); }
  catch { toast.error("Couldn't copy the link."); }
};

export const Footer = () => (
  <footer className="bg-[#1A1A1A] text-[#D1CCC5] mt-24">
    <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-[#D9CBA0]/60 to-transparent" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 grid md:grid-cols-4 gap-12">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3 mb-5">
          <div className="h-16 w-16 gh-octagon bg-black flex items-center justify-center overflow-hidden ring-1 ring-[#D9CBA0]/50">
            <img src={BRAND.logo} alt="Hope & Favor" className="h-full w-full object-contain" />
          </div>
          <div className="font-heading text-3xl text-[#D9CBA0] tracking-tight">Hope &amp; Favor</div>
        </div>
        <p className="font-hand text-2xl text-[#C4A4A4] mb-4">We are so grateful you are here.</p>
        <p className="text-sm text-[#8A8175] max-w-sm leading-relaxed tracking-wide">{BRAND.motto}</p>
      </div>
      <div>
        <h4 className="gh-overline text-[#D9CBA0] mb-5">Explore</h4>
        <ul className="space-y-3 text-sm">
          {[["/shop","Shop All"],["/build-your-own-box","Build Your Box"],["/subscriptions","Subscriptions"],["/digital-downloads","Digital Downloads"],["/blog","Blog"],["/policies","Policies"],["/terms","Terms & Conditions"],["/policies#ip","Copyright & IP"]].map(([to,l]) => (
            <li key={to}><Link to={to} className="text-[#D1CCC5] hover:text-[#D9CBA0] transition-colors" data-testid={`footer-${to.slice(1).replace(/[#/]/g,"-")}`}>{l}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="gh-overline text-[#D9CBA0] mb-5">Reach Us</h4>
        <div className="font-heading text-xl text-[#FAF7F2] mb-4">{BRAND.owner}</div>
        <ul className="space-y-3 text-sm">
          <li className="flex items-center gap-2.5"><Phone className="h-4 w-4 text-[#8E9A86]" /><a href={`tel:${BRAND.phone}`} className="hover:text-[#D9CBA0]">{BRAND.phone}</a></li>
          <li className="flex items-center gap-2.5"><Mail className="h-4 w-4 text-[#8E9A86]" /><a href={`mailto:${BRAND.email}`} className="hover:text-[#D9CBA0] break-all">{BRAND.email}</a></li>
          <li className="flex items-center gap-2.5"><Globe className="h-4 w-4 text-[#8E9A86]" />{BRAND.site}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-[#D9CBA0]/15">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 space-y-4">
        <p className="text-[11px] leading-relaxed text-[#8A8175] tracking-wide max-w-4xl" data-testid="footer-copyright-notice">
          © {new Date().getFullYear()} Hope &amp; Favor. All Rights Reserved. All original 3D floral resin sculptures, custom gift box arrangements, website imagery, and product designs displayed on this website are protected under United States and international copyright laws. Unauthorized duplication, modification, or distribution is strictly prohibited.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#8A8175] tracking-wide">
          <span>{BRAND.legal} · Made with <Heart className="inline h-3 w-3 text-[#C4A4A4]" /> and gratitude.</span>
          <div className="flex items-center gap-4">
            <button onClick={shareSite} data-testid="footer-share" className="inline-flex items-center gap-1.5 text-[#8A8175] hover:text-[#D9CBA0] transition-colors"><Share2 className="h-3.5 w-3.5" /> Share Hope &amp; Favor</button>
            <Link to="/policies#ip" data-testid="footer-copyright-link" className="text-[#8A8175] hover:text-[#D9CBA0] transition-colors">Copyright</Link>
            <Link to="/login" data-testid="footer-admin-link" className="text-[#8A8175] hover:text-[#D9CBA0] transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </div>
  </footer>
);
